export const MAXIMUM_REASON_LENGTH_SUPPORTED = 1000;
export const EMPTY_STRING = "";
